
import InputField from '@/components/UntitledUI/InputField.vue'
import Badge from '@/components/UntitledUI/Badge.vue'
import Taps from '@/components/UntitledUI/Tabs/Tabs.vue'
import Tap from '@/components/UntitledUI/Tabs/Tab.vue'
import SearchFilter from '@/components/Search/Filtering/SearchFilter.vue'

export default {
    name: 'DateSearchFilter',
    components: {
        SearchFilter,
        InputField,
        Badge,
        Taps,
        Tap
    },
    props: {
        tag: {
            type: Object,
            required: true
        },
        isActive: {
            type: Boolean,
            default: false
        },
        selectedFilters: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            isChanged: false,
            startDate: null,
            endDate: null,
            focused: null,
            calendar: null,
            startLabel: this.$t('ابتداءاً من'),
            endLabel: this.$t('انتهاءاً بـ')
        }
    },
    computed: {
        dateValue () {
            const values = []
            if (this.startDate) {
                values.push(this.startLabel + ': ' + this.startDate)
            }
            if (this.endDate) {
                values.push(this.endLabel + ': ' + this.endDate)
            }
            return values
        },
        tagsValue () {
            let value = '~'
            if (this.startDate) {
                value = this.startDate + value
            }
            if (this.endDate) {
                value = value + this.endDate
            }
            return value.length === 1 ? null : value
        },
        minStartDate () {
            return this.tag.extra[this.calendar === 'hijri' ? 'h' : 'g'][0]
        },
        maxStartDate () {
            if (!this.endDate) {
                return this.tag.extra[this.calendar === 'hijri' ? 'h' : 'g'][1]
            }
            return this.endDate
        },
        minEndDate () {
            if (!this.startDate) {
                return this.tag.extra[this.calendar === 'hijri' ? 'h' : 'g'][0]
            }
            return this.startDate
        },
        maxEndDate () {
            return this.tag.extra[this.calendar === 'hijri' ? 'h' : 'g'][1]
        },
        multiCalendar () {
            return !this.empty && Object.keys(this.tag.extra).length > 1
        },
        selectedValues () {
            return this.selectedFilters[this.tag.keyId] ?? null
        },
        empty () {
            return this.tag.extra === undefined || this.tag.extra === null || typeof this.tag.extra !== 'object' || Object.keys(this.tag.extra).length === 0
        }
    },
    watch: {
        selectedValues: {
            handler (value) {
                if (typeof value === 'string') {
                    if (value.startsWith('~')) {
                        this.endDate = value.substring(1)
                    } else if (value.endsWith('~')) {
                        this.startDate = value.substring(0, value.length - 1)
                    } else {
                        [this.startDate, this.endDate] = value.split('~')
                    }
                } else {
                    this.startDate = null
                    this.endDate = null
                }
            },
            immediate: true
        },
        tagsValue () {
            this.focused = null
            this.change()
        },
        calendar () {
            this.focused = null
        },
        'tag.extra' () {
            this.init()
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.focused = null
            if (this.empty) {
                return
            }
            this.$nextTick(() => {
                if (this.multiCalendar) {
                    if (!this.startDate && !this.endDate) {
                        this.calendar = 'gregorian'
                    } else {
                        const date = this.startDate ?? this.endDate
                        this.calendar = this.getCalendarFromYear(date)
                    }
                } else {
                    this.calendar = Object.keys(this.tag.extra)[0] === 'h' ? 'hijri' : 'gregorian'
                }
            })
        },
        reset () {
            this.startDate = null
            this.endDate = null
        },
        inputFocused (type) {
            this.focused = type
        },
        setDate (type, value) {
            this[type + 'Date'] = value
        },
        removeValue (option) {
            if (this.dateValue.length === 1) {
                this.reset()
            }
            if (option.includes(this.startLabel)) {
                this.startDate = null
            }
            if (option.includes(this.endLabel)) {
                this.endDate = null
            }
            this.change()
        },
        getCalendarFromYear (date) {
            if (Array.isArray(this.tag.extra.h) && date >= this.tag.extra.h[0] && date <= this.tag.extra.h[1]) {
                return 'hijri'
            }
            return 'gregorian'
        },
        change () {
            this.$emit(this.tagsValue ? 'add-filter' : 'remove-filter', {
                key: this.tag.keyId,
                value: this.tagsValue
            })
        },
        setCalendar (value, reset = false) {
            this.startDate = this.endDate = null
            this.calendar = value
        }
    }
}
